import { Options } from 'ky';

import Api from './ApiProvider';
import { FeatureToggleList, normalizeFeatureToggle } from './types';

export const getFeatureToggles = async (options?: Options) => {
  return Api.get('v2/store/feature-toggles', {
    ...options,
  }).json<FeatureToggleList>();
};

export const getNormalizedFeatureToggles = async (options?: Options) => {
  const data = await getFeatureToggles(options);

  return normalizeFeatureToggle(data);
};
